/**
 * Represents a home label component.
 */
export default class HomeLabel {
  /**
   * Creates an instance of HomeLabel.
   */
  constructor() {
    this.id = 'summaryCardLabel';
  }

  /**
   * Sets the information for the label.
   *
   * @param {Object} summaryCard - The summary card object.
   */
  setInformation(summaryCard) {
    this.Status = summaryCard.Status;
    this.isFeaturedListing = summaryCard.IsFeaturedListing;
  }

  getClassVariation() {    
    if (this.isFeaturedListing) {
      return 'nhs-c-listing-status--spotlight';
    }

    return '';
  }

  /**
   * Gets the HTML element with the specified ID.
   * @returns {HTMLElement} The HTML anchor element.
   */
  getElement() {
    return document.getElementById(this.id);
  }

  /**
   * Get the text for the home label based on the status and featured listing flag.
   * @returns {string} The text for the home label.
   */
  getText() {
    if (this.isFeaturedListing) {
      return 'Spotlight';
    }

    return '';
  }

  /**
   * Returns the HTML representation of the summary card.
   * @returns {string} The HTML string representing the summary card.
   */
  getHtml() {
    const text = this.getText();

    if (!text) {
      return '';
    }

    return `<span class="nhs-c-listing-status ${this.getClassVariation()}">${this.getText()}</span>`;
  }
}
